<template>
<Dialog :header="headertext" 
v-model:visible="$store.state.evaluation.show_evidence_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
>


<!--
<template v-if="$store.state.evaluation.viewingmode=='admin_submitting'">

  <template v-if="!$store.state.evaluation.selected_inputfield">
    <Button :label="$store.state.languages.lang_phrases.tedarikciden_kanit_iste"
     @click="letSupplierUploadFiles" class=" p-button-primary p-button-outlined  p-button-sm mb-4" :loading="$store.state.ui.submitting"/>
  </template>

  <template v-if="$store.state.evaluation.selected_inputfield">
    <Button :label="$store.state.languages.lang_phrases.tedarikci_kanit_yuklemeyi_kapat" 
     @click="abortSupplierUploadFiles" class=" p-button-danger p-button-outlined  p-button-sm mb-4" :loading="$store.state.ui.submitting"/>
  </template>
</template>-->


<template v-if="displayuploader">
  <FileUpload name="cover_image[]"  @select="onFilesAdded"  @remove="onFilesAdded"   v-model="files" :multiple="true" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin"    :maxFileSize="10000000000" class="" :fileLimit="$store.state.evaluation.active_inputfield.max_evidences">
  <template #empty>
      <div class="uploader_empty">
      <span class="material-icons-outlined md-48 mr-2">backup
    </span>
      <p>Dosyaları buraya sürükleyip bırakın</p>
    </div>
  </template>
</FileUpload>
</template>



<small  class="p-error pt-2" v-if="has_error"> {{$store.state.languages.lang_phrases.lutfen_en_az_bir_dosya_ekleyin}}</small>




<template v-if="loading_files">
<FrameOverlay></FrameOverlay>
</template>


<template v-else>
<template v-if="evidences.length">
  <template v-if="!items_readonly">
<h3 class="text-primary">{{$store.state.languages.lang_phrases.daha_once_yuklenen_kanit_dosyalari}}</h3>
</template>

<ScrollPanel style="width: 100%; height: 250px">
<div class="grid" v-for="item in evidences">

<div class="col-10">
<a class="p-text-secondary" :href="apiurl+item.filepath" target="_blank">{{item.filename}}</a>
</div>

<div class="col-2">
<Button  icon="pi pi-trash" v-if="displayuploader" @click="deleteEvidence(item.id)" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>	
</div>

</div>
</ScrollPanel>
</template>
</template>



<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="submitting" :disabled="!files.length"/>
</template>

</Dialog>	
</template>

<script>
export default {

  name: 'EvidenceModal',

  data () {
    return {
    	files:[],
    	evidences:[],
    	has_error:false,
    	submitting:false,
    	loading_files:true,
    }
  },
  sockets: {
    upload_allowed(data) {
      console.log("%c upload_allowed ","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data)      
      this.$store.dispatch('evaluation/setSelectedInputfield',data) 
    },
    upload_disallowed(data) {
      console.log("%c upload_allowed ","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data)     
      this.$store.dispatch('evaluation/setSelectedInputfield',null)  
    },    
    evidences_renewed(data) {
      console.log("%c upload_allowed ","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data)     
      setTimeout(()=>{
        this.getData()
      },100) 
    },
  },
  computed:{
    displayuploader()
    {
      let mode = this.$store.state.evaluation.viewingmode
      let selected_inputfield = this.$store.state.evaluation.selected_inputfield
      if(mode=="submitting" || mode=="admin_submitting")
      {
        return true
      }
      else
      {
        if(selected_inputfield && selected_inputfield.id == this.$store.state.evaluation.active_inputfield.id)
        {
          return true
        }
        else
        {
          return false
        }
      }

    },
    apiurl()
    {
      let api =  process.env.VUE_APP_API_HOOK
      api = api.replace("/api/","/")
      return api
      //return "https://storage.googleapis.com/verifycloud/"
    },
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
  	modalstate()
  	{
  		return this.$store.state.evaluation.show_evidence_modal
  	},
    items_readonly()
    {
      if(this.$store.state.evaluation.active_inputfield)
      {
        let active_inputfield = this.$store.state.evaluation.active_inputfield
        if(active_inputfield.read_only_state)
        {
          return true
        }
        else
        {
          return false
        }
      }
      else
      {
        return false
      }
    },
    headertext()
    {
      if(this.$store.state.evaluation.active_inputfield)
      {
        let active_inputfield = this.$store.state.evaluation.active_inputfield
        if(active_inputfield.read_only_state)
        {
          return this.$store.state.languages.lang_phrases.daha_once_yuklenen_kanit_dosyalari
        }
        else
        {
          return this.$store.state.languages.lang_phrases.lutfen_ilgili_alan_icin_kanit_dosyalarinizi_yukleyin
        }
      }
      else
      {
        return this.$store.state.languages.lang_phrases.lutfen_ilgili_alan_icin_kanit_dosyalarinizi_yukleyin
      }
    }
  },
  watch:{
    selectedinputfield(newval)
    {

    },
  	deletedstate(newVal,oldVal)
  	{
      console.log("deletedstate")
  		if(newVal)
  		{
  			this.getData()
        //this.$socket.emit('renew_evidences', { selected_inputfield: this.$store.state.evaluation.active_inputfield.id,flowsupplier_uuid: this.$route.params.id })
  		}
  	},
  	modalstate(newVal,oldVal)
  	{
  		if(newVal)
  		{        
  			this.getData()
  		}
  	},
  },
  methods:{
    letSupplierUploadFiles()
    {
      let active_inputfield = this.$store.state.evaluation.active_inputfield
      this.$store.dispatch('evaluation/setSelectedInputfield',active_inputfield) 
      //this.$socket.emit('let_supplier_upload_files', { selected_inputfield: active_inputfield,flowsupplier_uuid: this.$route.params.id })
    },
    abortSupplierUploadFiles()
    {
      let active_inputfield = this.$store.state.evaluation.active_inputfield
      this.$store.dispatch('evaluation/setSelectedInputfield',null) 
      //this.$socket.emit('abort_supplier_upload_files', { selected_inputfield: active_inputfield,flowsupplier_uuid: this.$route.params.id })
    },

    
  	async getData()
  	{
  		this.loading_files = await true
  		this.evidences = await this.silentApiGet("audit/get_inputfield_evidence/"+this.$store.state.evaluation.active_inputfield.submissions[0].id) 
      await console.log(this.evidences)
      let all_ind = this.$store.state.evaluation.inputfields.findIndex((item)=>{return item.id == this.$store.state.evaluation.active_inputfield.id})
      this.$store.state.evaluation.inputfields[all_ind].submissions[0].evidences = this.evidences

      let inputfield = await this.checkSingleInputfieldCompletion(this.$store.state.evaluation.inputfields[all_ind])
      await console.log(inputfield)
      this.$store.state.evaluation.inputfields[all_ind] = inputfield
      await this.calculateEvaluationProgress("first_init")
  		this.loading_files = await false
  	},
  	 onFilesAdded(event)
    {

      this.files = []
      for(let file of event.files)
      {
        this.files.push(file)
      }
    },
  	close()
  	{
      this.files = []
  		this.$store.dispatch('evaluation/setEvidenceModal',false) 
      this.abortSupplierUploadFiles()
  	},
  	typing()
  	{
  		this.has_error = false
  	},
  	submit()
  	{
  		this.submitting = true
  		if(!this.files.length)
  		{
  			this.has_error = true
  			this.submitting = false
  			return  false
  			//this.$store.dispatch('evaluation/setNullModal',false) 
  		}
  		let formdata = new FormData()
  		
  		formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.uuid)
	  		for( var i = 0; i < this.files.length; i++ ){
	        let file =  this.files[i];
	        formdata.append('files[' + i + ']', file);
	      }
  		
  		//return false
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
  		this.generalSubmission(formdata,"audit/submit_inputfield_evidence/"+this.$store.state.evaluation.active_inputfield.id,this.afterSubmit)
  	},
  	afterSubmit(response)
  	{
  		
      this.files = []
     	this.$store.dispatch('evaluation/setEvidenceModal',false) 
     	this.submitting = false
      this.afterSubmitAuditInputData(response)
      //this.$socket.emit('renew_evidences', { selected_inputfield: this.$store.state.evaluation.active_inputfield.id,flowsupplier_uuid: this.$route.params.id })
  	},
  	deleteEvidence(id)
  	{
  		this.deleteItem("inputfield_evidence",id)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>